import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export function fmtDate(s) {
    if (!s) return "—";
    try {
        return dayjs(s).format("YYYY-MM-DD HH:mm:ss");
    } catch {
        return s;
    }
}

export function fmtRel(s) {
    if (!s) return "—";
    try {
        return dayjs(s).fromNow();
    } catch {
        return s;
    }
}

export function fmtBytes(n) {
    n = Number(n) || 0;
    if (n < 1024) return `${n} B`;
    const u = ["KB", "MB", "GB", "TB", "PB"];
    let i = -1;
    let v = n;
    do {
        v /= 1024;
        i += 1;
    } while (v >= 1024 && i < u.length - 1);
    return `${v.toFixed(v >= 100 || i === 0 ? 0 : 1)} ${u[i]}`;
}

export function statusBadgeClass(status) {
    const m = {
        active: "cm-badge-success",
        succeeded: "cm-badge-success",
        running: "cm-badge-info",
        provisioning: "cm-badge-info",
        updating: "cm-badge-info",
        queued: "cm-badge-warning",
        pending: "cm-badge-warning",
        suspended: "cm-badge-neutral",
        canceled: "cm-badge-neutral",
        stopped: "cm-badge-neutral",
        offline: "cm-badge-neutral",
        online: "cm-badge-success",
        enrolled: "cm-badge-warning",
        deleting: "cm-badge-danger",
        redemption: "cm-badge-danger",
        failed: "cm-badge-danger",
        error: "cm-badge-danger",
    };
    return `cm-badge ${m[status] || "cm-badge-neutral"}`;
}

// Nextcloud direct-login URL: appends `/login?direct=1` so the local NC login
// form opens instead of auto-redirecting to an external IdP (SSO/SAML/OIDC/
// social login). Used for the "open" links in credential modals — an admin
// clicking there wants the local admin login, not the customer's external auth.
export function directLoginUrl(u) {
    if (!u) return u;
    const base = String(u).trim().replace(/\/+$/, "");
    if (!base) return u;
    return `${base}/login?direct=1`;
}

